import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X, ChevronDown } from 'lucide-react'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const navLinks = [
    { name: 'Accueil', path: '/' },
    { 
      name: 'À Propos', 
      path: '#',
      submenu: [
        { name: 'Notre histoire', path: '/a-propos/notre-histoire' },
        { name: 'Présentation', path: '/a-propos/presentation' },
        { name: 'Mot du DG', path: '/a-propos/mot-du-dg' },
        { name: 'Organigramme', path: '/a-propos/organigramme' },
        { name: 'Experts', path: '/a-propos/experts' },
        { name: 'Nos Locaux et Matériels', path: '/a-propos/locaux-et-materiels' },
      ]
    },
    { name: 'Programmes', path: '/programmes' },
    { 
      name: 'Projets', 
      path: '/projets',
      submenu: [
        { name: 'Projets en cours', path: '/projets#en-cours' },
        { name: 'Projets archivés', path: '/projets#archive' },
        { name: 'Formation professionnelle continue et séminaires réalisés', path: '/projets#seminaires' },
      ]
    },
  ]

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4 text-white'
    } ${location.pathname !== '/' && 'bg-cidh-blue text-white'}`}>
      <div className="container mx-auto px-4 md:px-6 flex justify-between items-center text-inherit">
        <Link to="/" className="flex items-center gap-2">
          <img 
            src="/logo.png" 
            alt="CIDH Consulting Logo" 
            className="h-20 w-auto object-contain"
          />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <div key={link.name} className="relative group">
              <Link 
                to={link.path} 
                className={`flex items-center gap-1 font-medium hover:text-cidh-gold transition-colors ${
                  isScrolled || location.pathname !== '/' ? 'text-cidh-gray-text' : 'text-white'
                }`}
              >
                {link.name}
                {link.submenu && <ChevronDown size={16} />}
              </Link>
              
              {link.submenu && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-white shadow-lg rounded-md py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
                  {link.submenu.map((sub) => (
                    <Link 
                      key={sub.name} 
                      to={sub.path}
                      className="block px-4 py-2 text-cidh-gray-text hover:bg-cidh-gray-light hover:text-cidh-blue transition-colors"
                    >
                      {sub.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
          <Link to="/contact" className="btn-primary py-2 px-5 text-sm">Nous Contacter</Link>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden p-2" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white text-cidh-gray-text absolute top-full left-0 w-full shadow-xl animate-fade-in">
          <div className="flex flex-col p-4 gap-4">
            {navLinks.map((link) => (
              <div key={link.name}>
                <Link 
                  to={link.path} 
                  className="text-lg font-semibold block"
                  onClick={() => !link.submenu && setIsOpen(false)}
                >
                  {link.name}
                </Link>
                {link.submenu && (
                  <div className="ml-4 mt-2 flex flex-col gap-2 border-l-2 border-cidh-gold pl-4">
                    {link.submenu.map((sub) => (
                      <Link 
                        key={sub.name} 
                        to={sub.path}
                        className="text-gray-600"
                        onClick={() => setIsOpen(false)}
                      >
                        {sub.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </nav>
  )
}

export default Navbar
